import React from 'react';
import { ChevronDown } from 'lucide-react';
const navItems = [{
  label: 'Home',
  hasDropdown: false,
  action: 'home'
}, {
  label: 'Lift Kits',
  hasDropdown: true,
  action: 'archive'
}, {
  label: 'Leveling Kits',
  hasDropdown: true,
  action: 'archive'
}, {
  label: 'Suspension',
  hasDropdown: true,
  action: 'archive'
}, {
  label: 'Shop All',
  hasDropdown: false,
  action: 'archive'
}];
const utilityLinks = ['Warranty', 'Instructions', 'Contact'];
interface NavigationProps {
  onNavigate?: (page: 'home' | 'archive' | 'detail', productId?: number) => void;
}
export function Navigation({
  onNavigate
}: NavigationProps) {
  return <nav className="w-full bg-primary text-white hidden lg:block shadow-md relative z-40" data-id="element-129">
      <div className="max-w-[1400px] mx-auto px-8 h-[52px] flex items-center justify-between" data-id="element-130">
        {/* Main Nav Items */}
        <ul className="flex items-center h-full" data-id="element-131">
          {navItems.map(item => <li key={item.label} className="h-full" data-id="element-132">
              <button onClick={() => onNavigate && onNavigate(item.action as any)} className="h-full flex items-center gap-1 px-6 font-heading font-bold text-xl uppercase italic tracking-wide hover:bg-black/10 transition-colors border-r border-white/10 last:border-r-0" data-id="element-133">
                {item.label}
                {item.hasDropdown && <ChevronDown className="w-4 h-4 mt-0.5 opacity-80" data-id="element-134" />}
              </button>
            </li>)}
        </ul>

        {/* Utility Links */}
        <ul className="flex items-center gap-8" data-id="element-135">
          {utilityLinks.map(link => <li key={link} data-id="element-136">
              <a href="#" className="font-heading text-lg font-medium italic hover:text-charcoal transition-colors tracking-wide opacity-90 hover:opacity-100" data-id="element-137">
                {link}
              </a>
            </li>)}
        </ul>
      </div>
    </nav>;
}